import { RESET_USER } from ".";
import { methods } from "../constants/constants";
import { getUsuarioById } from "../utils/dataHandlers/UsuariosDataHandler";

export const types = {
  GET_USUARIOS_BEGINS: 'USUARIOS/GET_USUARIOS_BEGINS',
  GET_USUARIOS_SUCCESS: 'USUARIOS/GET_USUARIOS_SUCCESS',
  GET_USUARIOS_FAILURE: 'USUARIOS/GET_USUARIOS_FAILURE',
  GET_USUARIOS_UPDATE: 'USUARIOS/GET_USUARIOS_UPDATE',

  POST_USUARIOS_BEGINS: 'USUARIOS/POST_USUARIOS_BEGINS',
  POST_USUARIOS_SUCCESS: 'USUARIOS/POST_USUARIOS_SUCCESS',
  POST_USUARIOS_FAILURE: 'USUARIOS/POST_USUARIOS_FAILURE',
  RESET_POST_USUARIOS: 'USUARIOS/RESET_POST_USUARIOS',

  EDIT_USUARIOS_BEGINS: 'USUARIOS/EDIT_USUARIOS_BEGINS',
  EDIT_USUARIOS_SUCCESS: 'USUARIOS/EDIT_USUARIOS_SUCCESS',
  EDIT_USUARIOS_FAILURE: 'USUARIOS/EDIT_USUARIOS_FAILURE',
  RESET_EDIT_USUARIOS: 'USUARIOS/RESET_EDIT_USUARIOS',


  DELETE_USUARIOS_BEGINS: 'USUARIOS/DELETE_USUARIOS_BEGINS',
  DELETE_USUARIOS_SUCCESS: 'USUARIOS/DELETE_USUARIOS_SUCCESS',
  DELETE_USUARIOS_FAILURE: 'USUARIOS/DELETE_USUARIOS_FAILURE',
  RESET_DELETE_USUARIOS: 'USUARIOS/RESET_DELETE_USUARIOS',

  DELETE_BATCH_USUARIOS_BEGINS: 'USUARIOS/DELETE_BATCH_USUARIOS_BEGINS',
  DELETE_BATCH_USUARIOS_SUCCESS: 'USUARIOS/DELETE_BATCH_USUARIOS_SUCCESS',
  DELETE_BATCH_USUARIOS_FAILURE: 'USUARIOS/DELETE_BATCH_USUARIOS_FAILURE',
  RESET_DELETE_BATCH_USUARIOS: 'USUARIOS/RESET_DELETE_BATCH_USUARIOS',

  GET_ROLES_BEGINS: 'USUARIOS/GET_ROLES_BEGINS',
  GET_ROLES_SUCCESS: 'USUARIOS/GET_ROLES_SUCCESS',
  GET_ROLES_FAILURE: 'USUARIOS/GET_ROLES_FAILURE',
  GET_ROLES_UPDATE: 'USUARIOS/GET_ROLES_UPDATE',
}

export const initialState = {
  usuarios: [],
  usuariosFetching: false,
  usuariosError: null,

  usuariosStatus: null,
  usuariosStatusData: null,
  usuariosStatusFetching: false,
  usuariosStatusError: null,

  usuariosEditStatus: null,
  usuariosEditStatusData: null,
  usuariosEditStatusFetching: false,
  usuariosEditStatusError: null,

  usuariosDeleteStatus: null,
  usuariosDeleteStatusData: null,
  usuariosDeleteStatusFetching: false,
  usuariosDeleteStatusError: null,

  usuariosDeleteBatchStatus: null,
  usuariosDeleteBatchStatusData: null,
  usuariosDeleteBatchStatusFetching: false,
  usuariosDeleteBatchStatusError: null,

  roles: [],
  rolesFetching: false,
  rolesError: null

}

const UsuariosReducer = (state = initialState, action) => {
    switch (action.type) {
      case RESET_USER:
        return initialState;
      case types.GET_ROLES_BEGINS: {
          return {
              ...state,
              rolesFetching: true,
              rolesError: null,
          }
      }
      case types.GET_ROLES_SUCCESS: {
          const data = action.payload;
          return {
              ...state,
              roles: data,
              rolesFetching: false,
              rolesError: null,
          }
      }
      case types.GET_ROLES_FAILURE:
          return {
              ...state,
              rolesFetching: false,
              rolesError: action.payload,
      }
      case types.GET_USUARIOS_BEGINS: {
      return {
        ...state,
        usuariosFetching: true,
        usuariosError: null,
      }
      }
      case types.GET_USUARIOS_SUCCESS: {
        const data = action.payload;
        return {
          ...state,
          usuarios: data,
          usuariosFetching: false,
          usuariosError: null,
        }
      }
    case types.GET_USUARIOS_FAILURE:
      return { 
        ...state,
        usuariosFetching: false,
        usuariosError: action.payload,
      }
      case types.GET_USUARIOS_UPDATE: {
      const { data, method } = action.payload;
      const currentUsuarios = Array.isArray(state.usuarios) ? [...state.usuarios] : [];
      const sanitizedData = {
        ...data,
        contrasena: '',
      };
      const exist = getUsuarioById(currentUsuarios, sanitizedData.id);
      let updateUsuarios = currentUsuarios;

      if (method === methods.DELETE) {
        updateUsuarios = currentUsuarios.filter((usuario) => usuario.id !== sanitizedData.id);
      } else {
        if (!exist) {
          updateUsuarios = [...currentUsuarios, sanitizedData];
        } else {
          updateUsuarios = currentUsuarios.map((usuario) => (
            usuario.id === sanitizedData.id
              ? {
                  ...usuario,
                  ...sanitizedData,
                }
              : usuario
          ));
        }
      }
      return {
        ...state,
        usuarios: updateUsuarios,
        usuariosFetching: false,
        ususariosError: null,
      }
    }
    case types.POST_USUARIOS_BEGINS: {
      return {
        ...state,
        usuariosStatusFetching: true,
        usuariosStatusError: null,
      }
    }
    case types.POST_USUARIOS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        usuariosStatus: data.status,
        usuariosStatusData: data.data,
        usuariosStatusFetching: false,
        usuariosStatusError: null,
      }
    }
    case types.POST_USUARIOS_FAILURE:
      return { 
        ...state,
        usuariosStatusFetching: false,
        usuariosStatusError: action.payload,
      }
      case types.RESET_POST_USUARIOS:
      return { 
        ...state,
        usuariosStatus: null,
        usuariosStatusData: null,
        usuariosStatusFetching: false,
        usuariosStatusError: null,
      }
    case types.EDIT_USUARIOS_BEGINS: {
      return {
        ...state,
        usuariosEditStatusFetching: true,
        usuariosEditStatusError: null,
      }
    }
    case types.EDIT_USUARIOS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        usuariosEditStatus: data.status,
        usuariosEditStatusData: data.data,
        usuariosEditStatusFetching: false,
        usuariosEditStatusError: null,
      }
    }
    case types.EDIT_USUARIOS_FAILURE:
      return { 
        ...state,
        usuariosEditStatusFetching: false,
        usuariosEditStatusError: action.payload,
      }
    case types.RESET_EDIT_USUARIOS:
      return { 
        ...state,
        usuariosEditStatus: null,
        usuariosEditStatusData: null,
        usuariosEditStatusFetching: false,
        usuariosEditStatusError: null,
      }
    case types.DELETE_USUARIOS_BEGINS: {
      return {
        ...state,
        usuariosDeleteStatusFetching: true,
        usuariosDeleteStatusError: null,
      }
    }
    case types.DELETE_USUARIOS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        usuariosDeleteStatus: data.status,
        usuariosDeleteStatusData: data.data,
        usuariosDeleteStatusFetching: false,
        usuariosDeleteStatusError: null,
      }
    }
    case types.DELETE_USUARIOS_FAILURE:
      return { 
        ...state,
        usuariosDeleteStatusFetching: false,
        usuariosDeleteStatusError: action.payload,
      }
    case types.RESET_DELETE_USUARIOS:
      return { 
        ...state,
        usuariosDeleteStatus: null,
        usuariosDeleteStatusData: null,
        usuariosDeleteStatusFetching: false,
        usuariosDeleteStatusError: null,
      }
    case types.DELETE_BATCH_USUARIOS_BEGINS: {
      return {
        ...state,
        usuariosDeleteBatchStatusFetching: true,
        usuariosDeleteBatchStatusError: null,
      }
    }
    case types.DELETE_BATCH_USUARIOS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        usuariosDeleteBatchStatus: data.status,
        usuariosDeleteBatchStatusData: data.data,
        usuariosDeleteBatchStatusFetching: false,
        usuariosDeleteBatchStatusError: null,
      }
    }
    case types.DELETE_BATCH_USUARIOS_FAILURE:
      return {
        ...state,
        usuariosDeleteBatchStatusFetching: false,
        usuariosDeleteBatchStatusError: action.payload,
      }
    case types.RESET_DELETE_BATCH_USUARIOS:
      return {
        ...state,
        usuariosDeleteBatchStatus: null,
        usuariosDeleteBatchStatusData: null,
        usuariosDeleteBatchStatusFetching: false,
        usuariosDeleteBatchStatusError: null,
      }
  default:
    return state
  }
}

export const actions = {
    getRoles: () => ({ type: types.GET_ROLES_BEGINS }),
    successGetRoles: data => ({ type: types.GET_ROLES_SUCCESS, payload: data, }),
    errorGetRoles: error => ({ type: types.GET_ROLES_FAILURE, payload: error, }),

  getUsuarios: (forceRefresh = false) => ({ type: types.GET_USUARIOS_BEGINS, forceRefresh }),
  successGetUsuarios: data => ({ type: types.GET_USUARIOS_SUCCESS, payload: data, }),
  errorGetUsuarios: error => ({ type: types.GET_USUARIOS_FAILURE, payload: error, }),
  updateUsuarios: (data, method) => ({ type: types.GET_USUARIOS_UPDATE, payload: { data, method }, }),

  postUsuarios: usuario => ({ type: types.POST_USUARIOS_BEGINS, usuario }),
  successPostUsuarios: data => ({ type: types.POST_USUARIOS_SUCCESS, payload: data, }),
  errorPostUsuarios: error => ({ type: types.POST_USUARIOS_FAILURE, payload: error, }),
  resetPostUsuarios: () => ({ type: types.RESET_POST_USUARIOS }),

  editUsuarios: usuario => ({ type: types.EDIT_USUARIOS_BEGINS, usuario }),
  successEditUsuarios: data => ({ type: types.EDIT_USUARIOS_SUCCESS, payload: data, }),
  errorEditUsuarios: error => ({ type: types.EDIT_USUARIOS_FAILURE, payload: error, }),
  resetEditUsuarios: () => ({ type: types.RESET_EDIT_USUARIOS }),

  deleteUsuarios: usuario => ({ type: types.DELETE_USUARIOS_BEGINS, usuario }),
  successDeleteUsuarios: data => ({ type: types.DELETE_USUARIOS_SUCCESS, payload: data, }),
  errorDeleteUsuarios: error => ({ type: types.DELETE_USUARIOS_FAILURE, payload: error, }),
  resetDeleteUsuarios: () => ({ type: types.RESET_DELETE_USUARIOS }),

  deleteUsuariosBatch: usuarioIds => ({ type: types.DELETE_BATCH_USUARIOS_BEGINS, usuarioIds }),
  successDeleteUsuariosBatch: data => ({ type: types.DELETE_BATCH_USUARIOS_SUCCESS, payload: data, }),
  errorDeleteUsuariosBatch: error => ({ type: types.DELETE_BATCH_USUARIOS_FAILURE, payload: error, }),
  resetDeleteUsuariosBatch: () => ({ type: types.RESET_DELETE_BATCH_USUARIOS }),
}

export default UsuariosReducer;